import { Navigate } from "react-router-dom";

export default function OnboardingGate({ children }) {
  const isComplete = localStorage.getItem("kalibr_onboarding_complete") ||
                     localStorage.getItem("kalibr_welcome_seen");
  if (!isComplete) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}
